import { Anchor, Text } from "@mantine/core";
import { TERMS_OF_SERVICE_URL, PRIVACY_POLICY_URL } from "../types";

interface TermsAndConditionsProps {
  primaryColor: string;
}

export const TermsAndConditions = ({
  primaryColor,
}: TermsAndConditionsProps) => {
  return (
    <Text c="dimmed" size="xs">
      By signing up, you agree to{" "}
      <Anchor href={TERMS_OF_SERVICE_URL} target="_blank" c={primaryColor}>
        SmartWiz Terms of Service
      </Anchor>{" "}
      and{" "}
      <Anchor href={PRIVACY_POLICY_URL} target="_blank" c={primaryColor}>
        Privacy Policy.
      </Anchor>
    </Text>
  );
};
